export const NO_ENROLL_FEE = 'Tu cuota de inscripción aún no se ha pagado. Si deseas registrarte en un programa, este cargo se sumará a ese costo.';
export const DEFAULT_PROGRAM_IMAGE = '/assets/default-course-logo.png';
export const HEAD_TITLE = 'Legacy Christian University';
export const TRY_AGAIN = 'Volver a intentar';
export const SAVE_TEXT = 'Guardar';
export const SAVE_CHANGES_TEXT = 'Guardar cambios';
export const NOTIFICATION_SUCCESS = 'Éxito';
export const NOTIFICATION_ERROR = 'Error';
export const WEB_ASSETS_URL = `https://${process.env.VUE_APP_S3_UPLOADS_BUCKET}.s3.${process.env.VUE_APP_S3_REGION}.amazonaws.com`;
